import script from "./TreeView.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeView.vue?vue&type=script&setup=true&lang=js"

import "./TreeView.vue?vue&type=style&index=0&id=347abb8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347abb8f"]])

export default __exports__